// Func = limiting Scope for this file
var lastScrollTop = 0;

var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

//header image to be window height on homepage
resizeWindow();

(function(){

	//burger menu click
	let allBurgers = document.getElementsByClassName('js-burger-menu');
	for(let i =0; i < allBurgers.length; i++){
		allBurgers[i].addEventListener('click',function(e){
			e.preventDefault();
			let asideMenu = document.getElementsByClassName('menu-aside')[0];
			if(!asideMenu.classList.contains('open')){
				asideMenu.classList.add('open');
				document.getElementById('header').classList.add('open');
				this.classList.add('open');
				this.getElementsByClassName('text')[0].innerHTML = 'Close';
			} else {
				asideMenu.classList.remove('open');
				document.getElementById('header').classList.remove('open');
				this.classList.remove('open');
				this.getElementsByClassName('text')[0].innerHTML = 'Menu';
			}
		});
	}
	//columns hover/click event
	if(document.getElementsByClassName('column-block').length > 0){
		let allColumns = document.getElementsByClassName('column-block');
		for(let h=0; h < allColumns.length; h++){
			let itemsCol = allColumns[h].getElementsByClassName('item')
			for(let g = 0; g < itemsCol.length; g++){
				if(windowWidth > 1200){
					itemsCol[g].addEventListener('mouseenter', function(){
						let copyHeight = this.getElementsByClassName('copy')[0].clientHeight;
						this.getElementsByClassName('wrap')[0].classList.add('open');
						this.getElementsByClassName('wrap')[0].style.height = copyHeight + 'px';
					})
					itemsCol[g].addEventListener('mouseleave', function(){
						let copyHeight = this.getElementsByClassName('copy')[0].clientHeight;
						this.getElementsByClassName('wrap')[0].classList.remove('open');
						this.getElementsByClassName('wrap')[0].style.height = '0px';
					})
				} 
				if(windowWidth > 600){
					itemsCol[g].addEventListener('click', function(){
						let copyHeight = this.getElementsByClassName('copy')[0].clientHeight;
						if(!this.getElementsByClassName('wrap')[0].classList.contains('open')){
							this.getElementsByClassName('wrap')[0].classList.add('open');
							this.getElementsByClassName('wrap')[0].style.height = copyHeight + 'px';
						} else {
							this.getElementsByClassName('wrap')[0].classList.remove('open');
							this.getElementsByClassName('wrap')[0].style.height = '0px';
						}
					})
				}
				
				
				
			}
		}
	}

	let allNavLinks = document.getElementById('primary-nav').getElementsByTagName('a');
	for(let a = 0; a < allNavLinks.length; a++){
		allNavLinks[a].addEventListener('click', function(e){
			if(this.parentElement.getElementsByClassName('submenu').length > 0){
				e.preventDefault();
				let subMenu = this.parentElement.getElementsByClassName('submenu')[0]
				let subMenuHeight = subMenu.clientHeight + 50;
				if(!subMenu.classList.contains('open')){
					subMenu.classList.add('open');
					this.parentElement.style.height = subMenuHeight + 'px';
				} else {
					subMenu.classList.remove('open');
					this.parentElement.style.height =  '50px';
				}
			}
		});
	}

	window.onload = function() {

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
		resizeWindow();
		window.addEventListener('resize', function(){
			resizeWindow();
		});

		//check if there is image
		if(document.getElementsByClassName('header-img').length > 0){
			if(!document.getElementsByClassName('header-img')[0].classList.contains('noheader')){
				if(!document.getElementById('home')){
					document.getElementsByTagName('header')[0].classList.add('withheader')
				}
			}
		}

	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.add('scroll');
			document.getElementById('header').classList.remove('withheader');
		}
		if(document.getElementById('home')){
			if(windowWidth > 600){
				if(document.getElementsByClassName('header-opentable')[0].classList.contains('home')){
					document.getElementsByClassName('header-opentable')[0].classList.remove('home')
				}
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.remove('scroll');
			
		}
		if(document.getElementById('home')){
			if(windowWidth > 600){
				if(!document.getElementsByClassName('header-opentable')[0].classList.contains('home')){
					document.getElementsByClassName('header-opentable')[0].classList.add('home')
				}
			}
		} else {
			if(document.getElementsByClassName('header-img').length > 0){
				if(!document.getElementsByClassName('header-img')[0].classList.contains('noheader')){
				
					document.getElementsByTagName('header')[0].classList.add('withheader')
					
				}
			}
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function resizeWindow(){
	//calculate a new window size
	windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
	windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

	if(windowWidth > 1500){
		
		//columns
		if(document.getElementsByClassName('column-block').length > 0){
			let allColumns = document.getElementsByClassName('column-block');
			for(let y = 0; y < allColumns.length; y++){
				allColumns[y].classList.add('bigger');
				allColumns[y].style.height =  (windowWidth / 3) + 'px';
			}
		}
	} else {
		if(document.getElementsByClassName('column-block').length > 0){
			let allColumns = document.getElementsByClassName('column-block');
			for(let y = 0; y < allColumns.length; y++){
				allColumns[y].classList.remove('bigger');
			}
		}
	}
}